/* import __COLOCATED_TEMPLATE__ from './form-field-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();